import {
	createDetailsSaveRegistry,
	type DetailsCommitResult,
	type DetailsSaveController,
} from "@/features/entity-details";

export type TicketDetailsEditableField =
	| "name"
	| "priority"
	| "dueDate"
	| "status"
	| "assignee"
	| "description";

export type TicketDetailsCommitResult =
	DetailsCommitResult<TicketDetailsEditableField>;

export type TicketDetailsSaveController =
	DetailsSaveController<TicketDetailsEditableField>;

const registry = createDetailsSaveRegistry<TicketDetailsEditableField>();

/**
 * Provides a registerable save controller for Ticket Details autosave + nav guards.
 */
export const TicketDetailsSaveProvider = registry.Provider;

/**
 * Access the Details save registry (null outside provider).
 */
export const useTicketDetailsSaveRegistry = registry.useRegistry;

/**
 * Latest registered controller, or null when Details panel is unmounted.
 */
export const useTicketDetailsSaveController = registry.useController;
